import $ from 'jquery';

export default class Modal {
  init () {
    const preloadImage = elm => {
      const image = $(elm);
      image.attr('src', image.data('src'));
    };

    /*
    const config = {
      root: document.querySelector('#modal--site-shortcuts'),
      rootMargin: '21px 21px 21px 21px',
      threshold: 0.2,
    };

    // register the config object with an instance
    // of intersectionObserver
    let observer = new IntersectionObserver((entries, self) => {
      // iterate over each entry
      entries.forEach(entry => {
        // process just the images that are intersecting.
        // isIntersecting is a property exposed by the interface
        if (entry.isIntersecting) {
          // custom function that copies the path to the img
          // from data-src to src
          preloadImage(entry.target);
          // the image is now in place, stop watching
          self.unobserve(entry.target);
        }
      });
    }, config);
    */
    // Load images on modal open
    $('.modal').on('show.bs.modal', event => {
      const self = $(event.target);

      self.find('img').each((i, elm) => {
        preloadImage(elm);
      });

      /*
      self.find('img').each((i, elm) => {
        observer.observe(elm);
      });
      */
    });
  }
}
